module.exports = __webpack_public_path__ + "img/pscBoxbg2.dbf73bf5.png";